import cmos_ic_design from "../../components/ProgramCatalog/assets/cmos_ic_design.webp";
import entcImage from "../../components/CoursePage/assets/entc-logo.webp";
import cas_ceda from "../../components/CoursePage/assets/cas_ceda_logo.png";
import kithmin from "../../components/CoursePage/assets/instructor-img/Kithmin.jpg";
import udara from "../../components/CoursePage/assets/instructor-img/Udara_Mendis.jpg";
import hirusha from "../../components/CoursePage/assets/instructor-img/Hirusha_Madhuwantha.jpg";
import sajith from "../../components/CoursePage/assets/instructor-img/Sajitha Madugalle.jpeg";
import imasha from "../../components/CoursePage/assets/instructor-img/Imasha_Nethmal.png";
import lohan from "../../components/CoursePage/assets/instructor-img/Lohan_Atapattu.jpg";
import nilan from "../../components/CoursePage/assets/instructor-img/Nilan_Udayanga.png";
import subodha from "../../components/CoursePage/assets/instructor-img/Subodha Charles.webp";
import avishka from "../../components/CoursePage/assets/instructor-img/Avishka_Herath.jpeg";
import cmosICDesignFlayer1 from "../../components/CoursePage/assets/CMOSAnalog ICDesignandSimulation.webp";
import { ECourseStatus, ICourse } from "../utils/utils";

export const cmosICDesign: ICourse = {
  header: {
    courseImage: cmos_ic_design,
    programCategory: "Workshop",
    difficultyLevel: "Beginner",
    courseTitle: "CMOS Analog IC Design and Simulation",
    specialization: "Art of IC Design",
    courseDescription:
      "Analog ICs power the building blocks of modern electronics, from amplifiers to sensors. Master the complete flow from device physics to layout, simulation, and fabrication through a project-based learning approach. This program equips you with the knowledge and skills to succeed in the fast-growing semiconductor industry.Gain industry-ready expertise in 16 sessions.",
    registerButton: "Registration Closed!",
    registerLink: "",
    secondaryName: "",
  },
  headerSecondSection: {
    starCount: 5,
    reviewCount: 15,
    registrationDeadline: "4 May 2025",
    parameterOne: "Estimated Time:",
    parameterTwo: "16 weeks",
    parameterThree: "New Course",
    collaborationLogos: [
      {
        collaborationLogo: entcImage,
        collaborationLogosName: "ENTC Logo",
      },
      {
        collaborationLogo: cas_ceda,
        collaborationLogosName: "CAS Logo",
      },
    ],
  },
  courseOutline: [
    {
      session: "",
      sessionContent: [
        {
          heading: "Introduction to Analog IC Design and Basic Devices:",
          description:
            "Overview of the analog design ecosystem, MOS device physics, schematic and layout basics (NMOS/PMOS).",
          subContent: [],
        },
        {
          heading: "Fundamentals of Inverter Design and Simulation:",
          description:
            "Hands-on design of inverters using OSIC tools, schematic simulations with Xschem/ngspice, and basic layout using KLayout.",
          subContent: [],
        },
        {
          heading: "Single-Ended Amplifiers and Small-Signal Analysis:",
          description:
            "Theory, design, and schematic simulations of single-ended amplifiers; introduction to small-signal modelling and analysis.",
          subContent: [],
        },
        {
          heading: "Current Mirrors and Differential Amplifiers:",
          description:
            "Design principles, schematic simulations, and theoretical understanding of current mirrors and differential amplifiers.",
          subContent: [],
        },

        {
          heading: "Post-Layout Verification:",
          description:
            "Running LVS and PEX checks, OTA layout tasks, and post-layout simulation preparation.",
          subContent: [],
        },

        {
          heading: "Chip Integration and Fabrication Overview:",
          description:
            "Finalizing designs with I/O planning, guard rings, filler cells, and understanding CMOS fabrication, chip packaging, and submission processes.",
          subContent: [],
        },

        {
          heading: "Final Project Submission and Competition:",
          description:
            "Final project reviews, amplifier performance benchmarking (Area/Power/GBP), preparation for tapeout, and best design award competition.",
          subContent: [],
        },
      ],
    },
  ],
  faqs: [
    {
      question:
        "I have no prior knowledge of CMOS Analog IC Design and Simulation. Will I be able to do this course?",
      answer:
        "Yes. We teach all the required skills. The only expectation is that you have basic knowledge of mathematical concepts and engineering fundamentals",
    },
    {
      question:
        "Do I need electronic equipment/software licenses to complete this course?",
      answer:
        "Yes. You will need hardware to complete the course. We will facilitate the purchasing process during the course.",
    },
    {
      question:
        "Will I be able to build things at the end of the course, or is it only theory?",
      answer:
        "Of course, you will be able to build things. The course is outcome-oriented, so at the end of the course, you will know how to develop IoT products.",
    },
    {
      question: "Is the course taught online?",
      answer:
        "Yes. The course lectures are all conducted online. We will arrange hands-on sessions at ENTC laboratories as required.",
    },
    {
      question: "Will lecture recordings be made available?",
      answer:
        "Yes. All course materials will be made available through an online learning management system called Moodle. All paid participants will be granted access to the course Moodle page.",
    },
  ],
  experts: [
    {
      image: kithmin,
      name: "Mr. Kithmin Wickremasinghe",
      designation: "MASc, Electrical and Computer Eng., UBC, Canada",
    },
    {
      image: udara,
      name: "Ms. Udara Mendis",
      designation: "Double Degree Master's Student, TUHH, Germany",
    },

    {
      image: avishka,
      name: "Mr. Avishka Herath",
      designation: "Graduate, ENTC, UoM",
    },
    {
      image: hirusha,
      name: "Mr. Hirusha Madhuwantha",
      designation: "4th year Undergraduate, ENTC,  UoM",
    },
    {
      image: sajith,
      name: "Mr. Sajitha Madugalle",
      designation: "4th year Undergraduate, ENTC,  UoM",
    },
    {
      image: imasha,
      name: "Mr. Imasha Nethmal",
      designation: "4th year Undergraduate, ENTC,  UoM",
    },
    {
      image: lohan,
      name: "Mr. Lohan Atapattu",
      designation: "4th year Undergraduate, ENTC,  UoM",
    },

    {
      image: nilan,
      name: "Dr. Nilan Udayanga",
      designation: "Senior IC Designer, Cirtec Medical Corp.",
    },

    {
      image: subodha,
      name: "Dr. Subodha Charles",
      designation: "Senior Lecturer, ENTC, UoM",
    },
  ],
  studentReviews: [
    "On the 1st day, when I saw the registration details, I went through the course curriculum and I joined the course with an expectation. The team fulfilled my expectations 100%.",
    "The course is very interesting and provides a good knowledge in the intended learning area. I would like to see more courses like this in future.",
    "This was a great course. Although the instructors couldn't touch all the aspects, guiding the students on what to follow and refer to is a great thing. Grateful for the organizers and instructors sharing their knowledge. Hope to join the next courses as well.",
    "The personal ML/embedded projects that the instructors shared as case studies were really inspiring. Sharing the ups and downs and what to expect along this path is a real motivator!",
    "Flow of the content was really great. It will really help to beginners who are entering to ML & Edge computing.",
  ],
  facts: [],
  classSchedule: [],
  prerequisite:
    "Basic knowledge of mathematical concepts and engineering fundamentals",
  isCourseFlyer: true,
  flyer: {
    description:
      "Learn more about CMOS Analog IC Design and Simulation short course from the course announcement flyer",
    button: "View Flyer",
    image: cmosICDesignFlayer1,
  },
  /*   firstSessionFreeDetails: {
    instruction: {
      isInstructive: true,
      instructiveText:
        "The first session, which was free of charge to everyone, was held on 4th May 2025. The recording of the session is made available below.",
      instructiveTextSecond:
        "Only paid participants can attend from day 2 onwards. So, please complete the payment by",
      date: "",
      dateSecond: "on or before 6 june 2025.",
      buttonText: "View Course Outline",
      buttonTextInfo: "Download",
      viewIntruction: "",
      instructionVideoTopic:
        "Recording of the first session held on 4th May 2025",
      instructionVideoUrl: "9Yq707qduWk",
      videoTwoTopic: "Recording of the second session held on 4th May 2025",
      videoTwoUrl: "8MpwthQsj80",
      viewIntructionLink: "",
      buttonLink: "",
      buttonLinkInfo: "https://skillsurf.github.io/art_of_aicd/", //slides
      moreInformation:
        "For any questions, please email skillsurfedu@gmail.com.",
      slideButtonText: "Download Slides:",
      paymentInstructionButtonText: "here.",
      paymentInstructionButtonLink:
        "https://drive.google.com/file/d/1349tAfro50NWnKHHFzdfaHe5cULIXKuz/view?usp=drive_link",
      paymentInstructionText:
        "Payment and other related instructions can be found",
      enrollmentFormLink: "https://docs.google.com/forms/d/1Gxp33YTy6uyl7NCrpjjKL-Fd0T31MuTLHlqoxa3_Ois/edit",
    },
  }, */
  courseStatus: ECourseStatus.OLD,
  showTimer: false,
  isDifferentBullet: true,
  isResources: false,
  resourcesYoutubeLink: "https://www.youtube.com/@skillsurfedu",
  resourcesGitHubLink: "https://github.com/SkillSurf/introduction_genAI",
  timerDate: "2024-06-06 00:00",
  showSchedule: true,
};
